import api from './apiClient';
import { User } from '../types';

export const userService = {
  completeTour: async (page: string): Promise<{ message: string; completed_tours: string[]; onboarding_completed: boolean; completed_at?: string }> => {
    const response = await api.post('/users/onboarding/complete', { page });
    return response.data;
  },

  // Legacy: mantener por compatibilidad
  completeOnboarding: async (): Promise<{ message: string; completed: boolean; completed_at?: string }> => {
    const response = await api.post('/users/onboarding/complete');
    return response.data;
  },
  
  getUsers: async (params?: {
    role?: string;
    is_active?: boolean;
    page?: number;
    size?: number;
  }): Promise<User[]> => {
    const response = await api.get('/users/', { params });
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && Array.isArray(data.users)) {
      return data.users;
    }
    return [];
  },

  getUser: async (id: number): Promise<User> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  updateUser: async (id: number, data: Partial<User>): Promise<User> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: number): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  verifyUser: async (id: number, verified: boolean = true): Promise<{ message: string }> => {
    const response = await api.patch(`/users/${id}/verify?verified=${verified}`);
    return response.data;
  },

  deactivateMyAccount: async (reason: string): Promise<{ message: string }> => {
    const response = await api.post('/users/me/deactivate', { reason });
    return response.data;
  },

  getUserCount: async (): Promise<{
    current_count: number;
    max_users: number | null;
    remaining: number | null;
    is_full: boolean;
    limit_enabled: boolean;
  }> => {
    const response = await api.get('/system/settings/public/user-count');
    return response.data;
  },
};

export const appRatingService = {
  getMyRating: async (): Promise<any | null> => {
    try {
      const response = await api.get('/app-ratings/my');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
  
  createRating: async (data: any): Promise<any> => {
    const response = await api.post('/app-ratings/', data);
    return response.data;
  },
  
  updateRating: async (data: any): Promise<any> => {
    const response = await api.put('/app-ratings/my', data);
    return response.data;
  },
  
  getStats: async (): Promise<any> => {
    const response = await api.get('/app-ratings/stats');
    return response.data;
  },
  
  getAllRatings: async (params?: { skip?: number; limit?: number }): Promise<any[]> => {
    const response = await api.get('/app-ratings/admin/all', { params });
    return response.data;
  },
  
  respondToRating: async (ratingId: number, responseText: string): Promise<any> => {
    const response = await api.patch(`/app-ratings/admin/${ratingId}/respond`, null, {
      params: { response_text: responseText }
    });
    return response.data;
  },
};

